import ToggleButtons from './ToggleButtons'

import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'
import { type CardActivity, MC_QUESTION_TYPE_OPTIONS } from '@/models/card-activity/card-activity.model'

export function ToggleButtonGradingMethodMCCard({
  value,
  onChange,
}: {
  value: CardActivity['MCQType']
  onChange: (value: CardActivity['MCQType']) => void
}) {
  return (
    <ToggleButtons
      activeStyles={{
        bgcolor: '#fff',
        color: '#344054',
        fontWeight: 600,
        borderRadius: '6px',
      }}
      buttonStyles={{
        fontSize: 12,
      }}
      inactiveStyles={{
        color: '#667085',
      }}
      options={MC_QUESTION_TYPE_OPTIONS}
      toggleButtonStyles={{
        bgcolor: '#F9FAFB',
        fontSize: 12,
      }}
      value={value}
      // @ts-ignore
      onChange={(_, newValue) => {
        if (newValue == null) return

        onChange(newValue as CardActivityWithId['MCQType'])
      }}
    />
  )
}
